import { render } from "./ButtonParagraph.vue?vue&type=template&id=1edaf2d4"
import script from "./ButtonParagraph.vue?vue&type=script&lang=js"
export * from "./ButtonParagraph.vue?vue&type=script&lang=js"

import "./ButtonParagraph.vue?vue&type=style&index=0&id=1edaf2d4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__